import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";
import {makeFactAddressItems} from "../helpers/fact-address-items.js";

export default function FactAddress({ title, data }) {
    const address = makeFactAddressItems(data);

    return (
        <InfoGrid title={title} items={address} />
    )
}